import axios from "axios";
import { storeFront } from "../storefront/storefront";

export const productrecommendation = () => {
    window.addEventListener('load', async () => {
        
        let url = document.URL;
        let baseIndex = "";
        let baseUrl = "";
        let handle = "";
        let currentVariantColor = "";

        if ( url.includes('/products/') ) {
            baseIndex = url.indexOf('/products/');
            baseUrl = url.substring(0, baseIndex);
            handle = document.querySelector('.product-info').dataset.productHandle;
            const currentVariantColor_element = document.querySelector('variant-option-value');
            if ( currentVariantColor_element ) {
                currentVariantColor = currentVariantColor_element.textContent;
            }
            const currentVariantSize_element = document.querySelector('[data-b-option-value]');
            if ( currentVariantSize_element ) {
                currentVariantColor = currentVariantSize_element.textContent;
            }

        } else if ( url.includes('/cart') ) {
            baseIndex = url.indexOf('/cart');
            baseUrl = url.substring(0, baseIndex);
            const line_items = document.querySelectorAll('.line-item-handle');
            if ( line_items ) {
                for (const item of line_items) {
                    if (!(item.dataset.productHandle.includes('customization')) && !(item.dataset.productHandle.includes('gift'))) {
                      handle = item.dataset.productHandle;
                      currentVariantColor = item.parentElement.querySelector('.line-item-title').textContent;
                      break;
                    }
                }
            }
        }

        if ( handle != "" && currentVariantColor != "" ) {
            const productUrl = `${baseUrl}/products/${handle}.js`;
            const product = await getProductJson(productUrl);
            let waitFlag = false;

            
            let currentVariantId = "";
            product.variants.forEach( (variant) => {
                if ( variant.title == currentVariantColor ) {
                    currentVariantId = variant.id;
                }
            })
            const recommendColors = document.querySelector(`#recommendColor-${currentVariantId}`).value.split(',');
            setTimeout(() => {
                changeRecommendProduct(baseUrl, product, currentVariantColor, recommendColors, waitFlag);
            }, 1000);

            document.addEventListener('variant:change', function(event) {
                let url = document.URL;
                const baseIndex = url.indexOf('/products/');
                const baseUrl = url.substring(0, baseIndex);
                const product = event.detail.product;
                const currentVariantColor = event.detail.variant.title;
                const currentVariantId = event.detail.variant.id;
                const recommendColors = document.querySelector(`#recommendColor-${currentVariantId}`).value.split(',');
                if ( !waitFlag ) {
                    changeRecommendProduct(baseUrl, product, currentVariantColor, recommendColors, waitFlag);
                }
            });
        }
            
    });
}

const changeRecommendProduct = async (baseUrl, product, currentVariantColor, recommendColors, waitFlag) => {
    waitFlag = true;
    if ( product.options[0].name == "Color" || product.options[0].name == "カラー" || product.options[0].name == "color" ) {
        // define image src
        let image_src = "";
        // check product recommendation product
        const recommendSection = document.querySelector('product-recommendations');
        const product_cards = Array.from(recommendSection.querySelectorAll('product-card'));
        if (recommendSection && product_cards && product_cards.length) {
            const promises = product_cards.map( async (product_card) => {
                const product_card_image = Array.from(product_card.querySelectorAll('img'));
                const product_card_a = product_card.querySelector('a');
                let product_card_link = "";
                if ( product_card_a ) {
                    product_card_link = product_card_a.href;
                }
                const handle = product_card.getAttribute('handle');
                const url = `${baseUrl}/products/${handle}.js`
                const getProductInfo = await getProductJson(url);
                const defaultFeaturedImage = `https:${getProductInfo.featured_image}`;

                const response = await storeFront(handle);
                const variantArray = response.data.product.variants.nodes;

                let noExactMatchVariant = true;
                let noPartialExactMatchVariant = true;
                let noPartialMatchVariant = true;
                let noPartialTitleMatchVariant = true;
                for (const variant of getProductInfo.variants) {
                    const targetSku = variant.sku;
                    const targetValue = "normal";

                        if (variant.title == currentVariantColor ){

                            const isNormal = variantArray.some(item => item.sku === targetSku && (!(item.metafield) || (item.metafield.value === targetValue)));
                            if (isNormal && variant.featured_image) {
                                image_src = variant.featured_image.src;
                                const new_secset = `${image_src}&width=200 200w, ${image_src}&width=300 300w, ${image_src}&width=400 400w, ${image_src}&width=500 500w, ${image_src}&width=600 600w, ${image_src}&width=700 700w, ${image_src}&width=800 800w, ${image_src}&width=1000 1000w, ${image_src}&width=1200 1200w, ${image_src}&width=1400 1400w`;
                                product_card_image[0].setAttribute('src',image_src);
                                product_card_image[0].setAttribute('srcset',new_secset);
                                if ( product_card_image[1] ) {
                                    product_card_image[1].setAttribute('src',image_src);
                                    product_card_image[1].setAttribute('srcset',new_secset);
                                }
                                if ( product_card_link != "") {
                                    let url = product_card_link;
                                    if (url.includes("?variant=")) {
                                        let newVariantValue = variant.id;
                                        let newUrl = url.replace(/(\?variant=)[^\&]+/, "$1" + newVariantValue);
                                        
                                        // 新しいURLを使って何かを行う（例：リダイレクト）
                                        product_card_a.href = newUrl;
                                        
                                    } else {
                                        let newUrl = `${url}?variant=${variant.id}`;
                                        product_card_a.href = newUrl;
                                    }
                                }
                                noExactMatchVariant = false;
                                break;
                            }
                        }
                }
                if ( noExactMatchVariant ) {
                    let findPartialExactMarch = false;
                    for (const variant of getProductInfo.variants) {
                        const targetSku = variant.sku;
                        const targetValue = "normal";

                        if ( !findPartialExactMarch ) {
                            for (const recommendColor of recommendColors) {
                                if ( recommendColor != "" && variant.title == recommendColor ) {

                                    const isNormal = variantArray.some(item => item.sku === targetSku && (!(item.metafield) || (item.metafield.value === targetValue)));
                                    if (isNormal && variant.featured_image) {
                                        image_src = variant.featured_image.src;
                                        const new_secset = `${image_src}&width=200 200w, ${image_src}&width=300 300w, ${image_src}&width=400 400w, ${image_src}&width=500 500w, ${image_src}&width=600 600w, ${image_src}&width=700 700w, ${image_src}&width=800 800w, ${image_src}&width=1000 1000w, ${image_src}&width=1200 1200w, ${image_src}&width=1400 1400w`;
                                        product_card_image[0].setAttribute('src',image_src);
                                        product_card_image[0].setAttribute('srcset',new_secset);
                                        if ( product_card_image[1] ) {
                                            product_card_image[1].setAttribute('src',image_src);
                                            product_card_image[1].setAttribute('srcset',new_secset);
                                        }
                                        if ( product_card_link != "") {
                                            let url = product_card_link;
                                            if (url.includes("?variant=")) {
                                                let newVariantValue = variant.id;
                                                let newUrl = url.replace(/(\?variant=)[^\&]+/, "$1" + newVariantValue);
                                                
                                                // 新しいURLを使って何かを行う（例：リダイレクト）
                                                product_card_a.href = newUrl;
                                                
                                            } else {
                                                let newUrl = `${url}?variant=${variant.id}`;
                                                product_card_a.href = newUrl;
                                            }
                                        }
                                        noPartialExactMatchVariant = false;
                                        findPartialExactMarch = true;
                                        break;
                                    }
                                }
                            }
                        }
                    }
                }
                if ( noExactMatchVariant && noPartialExactMatchVariant ) {
                    let findPartialExactMarch = false;
                    for (const variant of getProductInfo.variants) {
                        const targetSku = variant.sku;
                        const targetValue = "normal";

                        if ( !findPartialExactMarch ) {
                            for (const recommendColor of recommendColors) {
                                if ( recommendColor != "" && variant.title.includes(recommendColor) ) {

                                    const isNormal = variantArray.some(item => item.sku === targetSku && (!(item.metafield) || (item.metafield.value === targetValue)));
                                    if (isNormal && variant.featured_image) {                                    
                                        image_src = variant.featured_image.src;
                                        const new_secset = `${image_src}&width=200 200w, ${image_src}&width=300 300w, ${image_src}&width=400 400w, ${image_src}&width=500 500w, ${image_src}&width=600 600w, ${image_src}&width=700 700w, ${image_src}&width=800 800w, ${image_src}&width=1000 1000w, ${image_src}&width=1200 1200w, ${image_src}&width=1400 1400w`;
                                        product_card_image[0].setAttribute('src',image_src);
                                        product_card_image[0].setAttribute('srcset',new_secset);
                                        if ( product_card_image[1] ) {
                                            product_card_image[1].setAttribute('src',image_src);
                                            product_card_image[1].setAttribute('srcset',new_secset);
                                        }
                                        if ( product_card_link != "") {
                                            let url = product_card_link;
                                            if (url.includes("?variant=")) {
                                                let newVariantValue = variant.id;
                                                let newUrl = url.replace(/(\?variant=)[^\&]+/, "$1" + newVariantValue);
                                                
                                                // 新しいURLを使って何かを行う（例：リダイレクト）
                                                product_card_a.href = newUrl;
                                                
                                            } else {
                                                let newUrl = `${url}?variant=${variant.id}`;
                                                product_card_a.href = newUrl;
                                            }
                                        }
                                        noPartialMatchVariant = false;
                                        findPartialExactMarch = true;
                                        break;
                                    }
                                }
                            }
                        }
                    }
                }
                if ( noExactMatchVariant && noPartialExactMatchVariant && noPartialMatchVariant ) {
                    let findPartialExactMarch = false;
                    for (const variant of getProductInfo.variants) {
                        
                        const targetSku = variant.sku;
                        const targetValue = "normal";

                        if ( !findPartialExactMarch ) {
                            
                                if ( variant.title.includes(currentVariantColor) || currentVariantColor.includes(variant.title) ) {
                                    const isNormal = variantArray.some(item => item.sku === targetSku && (!(item.metafield) || (item.metafield.value === targetValue)));
                                    if (isNormal && variant.featured_image) {                                    
                                        image_src = variant.featured_image.src;
                                        const new_secset = `${image_src}&width=200 200w, ${image_src}&width=300 300w, ${image_src}&width=400 400w, ${image_src}&width=500 500w, ${image_src}&width=600 600w, ${image_src}&width=700 700w, ${image_src}&width=800 800w, ${image_src}&width=1000 1000w, ${image_src}&width=1200 1200w, ${image_src}&width=1400 1400w`;
                                        product_card_image[0].setAttribute('src',image_src);
                                        product_card_image[0].setAttribute('srcset',new_secset);
                                        if ( product_card_image[1] ) {
                                            product_card_image[1].setAttribute('src',image_src);
                                            product_card_image[1].setAttribute('srcset',new_secset);
                                        }
                                        if ( product_card_link != "") {
                                            let url = product_card_link;
                                            if (url.includes("?variant=")) {
                                                let newVariantValue = variant.id;
                                                let newUrl = url.replace(/(\?variant=)[^\&]+/, "$1" + newVariantValue);
                                                
                                                // 新しいURLを使って何かを行う（例：リダイレクト）
                                                product_card_a.href = newUrl;
                                                
                                            } else {
                                                let newUrl = `${url}?variant=${variant.id}`;
                                                product_card_a.href = newUrl;
                                            }
                                        }
                                        noPartialTitleMatchVariant = false;
                                        findPartialExactMarch = true;
                                        break;
                                    }
                                }
                            
                        }
                    }
                }
                if (noExactMatchVariant && noPartialExactMatchVariant && noPartialMatchVariant && noPartialTitleMatchVariant) {

                    // featured imageではなくて、normalカラーを探すためにループ回す必要あり。
                    for (const variant of getProductInfo.variants) {
                        const targetSku = variant.sku;
                        const targetValue = "normal";

                        const isNormal = variantArray.some(item => item.sku === targetSku && (!(item.metafield) || (item.metafield.value === targetValue)));
                        if ( isNormal && variant.featured_image ) {
                            image_src = variant.featured_image.src;
                            const new_secset = `${image_src}&width=200 200w, ${image_src}&width=300 300w, ${image_src}&width=400 400w, ${image_src}&width=500 500w, ${image_src}&width=600 600w, ${image_src}&width=700 700w, ${image_src}&width=800 800w, ${image_src}&width=1000 1000w, ${image_src}&width=1200 1200w, ${image_src}&width=1400 1400w`;
                            product_card_image[0].setAttribute('src',image_src);
                            product_card_image[0].setAttribute('srcset',new_secset);
                            if ( product_card_image[1] ) {
                                product_card_image[1].setAttribute('src',image_src);
                                product_card_image[1].setAttribute('srcset',new_secset);
                            }
                            if ( product_card_link != "") {
                                let url = product_card_link;
                                if (url.includes("?variant=")) {
                                    let newVariantValue = variant.id;
                                    let newUrl = url.replace(/(\?variant=)[^\&]+/, "$1" + newVariantValue);
                                    
                                    // 新しいURLを使って何かを行う（例：リダイレクト）
                                    product_card_a.href = newUrl;
                                    
                                } else {
                                    let newUrl = `${url}?variant=${variant.id}`;
                                    product_card_a.href = newUrl;
                                }
                            }
                            break;
                        }
                    }
                    if ( image_src == "" ) {
                        image_src = defaultFeaturedImage;
                        const new_secset = `${image_src}&width=200 200w, ${image_src}&width=300 300w, ${image_src}&width=400 400w, ${image_src}&width=500 500w, ${image_src}&width=600 600w, ${image_src}&width=700 700w, ${image_src}&width=800 800w, ${image_src}&width=1000 1000w, ${image_src}&width=1200 1200w, ${image_src}&width=1400 1400w`;
                        product_card_image[0].setAttribute('src',image_src);
                        product_card_image[0].setAttribute('srcset',new_secset);
                        if ( product_card_image[1] ) {
                            product_card_image[1].setAttribute('src',image_src);
                            product_card_image[1].setAttribute('srcset',new_secset);
                        }
                    }
                    
                }
            })

            await Promise.all(promises);
        }
    }
    waitFlag = false;
}

const getProductJson = async (url) => {
    try {
        const response = await axios({
          headers: {
            "Content-Type": "application/json"
          },
          method: 'GET',
          url: url
        });
        return response.data;
      } catch (error) {
        console.log(error);
        throw new Error("Failed to get product JSON.");
      }
}